module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921033834_T.8f49c7c1.jpg";